import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getTerritory = createAsyncThunk(
  "territory/getTerritory",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getTerritory(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const territorySlice = createSlice({
  name: "territory",
  initialState,
  reducers: {
    setTerritoryList(state, action) {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTerritory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTerritory.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getTerritory.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const territoryObj = (state) => state.territory.value;
export const territoryObjLoader = (state) => state.territory.loading;
export const { setTerritoryList } = territorySlice.actions;

export default territorySlice.reducer;
